export const headerStyle = { padding: "30px 24px 0px 32px" };
